import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n } from 'i18next';

export function withTranslation<ComponentProps extends object>(
	WrappedComponent: React.ComponentType<ComponentProps>,
	i18nInit: i18n,
) {
	const displayName = WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component';

	const ComponentWithTranslation: React.ComponentType<ComponentProps> = (props) => (
		<I18nextProvider i18n={i18nInit}>
			<WrappedComponent {...props} />
		</I18nextProvider>
	);
	ComponentWithTranslation.displayName = `withTranslation(${displayName})`;

	return ComponentWithTranslation;
}
